import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { messages } from './languages';

// Só usa idioma salvo pelo usuário (localStorage). Sem cookie para não contribuir com tamanho de header.
// O front não grava cookies; config do backend fica em localStorage/memória.
i18n.use(LanguageDetector).init({
  debug: false,
  defaultNS: ['translations'],
  fallbackLng: 'pt',
  lng: 'pt',
  ns: ['translations'],
  resources: messages,
  detection: {
    order: ['localStorage'],
    caches: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
  },
});

export { i18n };
